'use client';

import dynamic from 'next/dynamic';
import type { ReactElement } from 'react';

const NewBookingWidgetModal = dynamic(
  () => import('../NewBookingWidgetDesign'),
  {
    ssr: false,
    loading: () => null,
  },
);

export function BookingWidgetClient(): ReactElement {
  return <NewBookingWidgetModal />;
}
